import { WarehouseAddressCollectionDataProvider } from '@steelbuy/data-provider';
import { CheckoutAddAddress } from '../../components/checkout/CheckoutAddAddress';

export const CheckoutAddAddressView = () => (
    <WarehouseAddressCollectionDataProvider>
        <CheckoutAddAddress />
    </WarehouseAddressCollectionDataProvider>
);
